import PropTypes from "prop-types";
import { useState, useEffect } from "react";

import classNames from "classnames";
import { formSubmitButton } from "@/assets/styles/common.module.scss";

import {
  fontSize14,
  fontSize16,
  fontWeight500,
} from "./modal_children.module.scss";
import ModalBox from "../ModalBox";
import Image from "next/image";
import { IMAGE_BASE_PATH } from "@/config/config";
import { isMobile } from "@/helpers/utils";

const ErrorMessageModal = ({ toggle, show, message, onClickSubmit }) => {
  const [mobileView, setMobileView] = useState(false);

  useEffect(() => {
    setMobileView(isMobile(window.innerWidth));
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    onClickSubmit();
    toggle();
  };

  return (
    <ModalBox show={show} toggle={toggle} showHeader={false}>
      <div
        className={classNames(
          "d-flex flex-column justify-content-center align-items-center color-primary text-center"
        )}
      >
        <div className="d-flex justify-content-center">
          <img src={`${IMAGE_BASE_PATH}/images/errorPage.svg`} alt="errorImg" />
          {/* <Image
            src={`${IMAGE_BASE_PATH}/images/errorPage.svg`}
            alt="errorImg"
            width={15}
            height={15}
          /> */}
        </div>
        <br />

        <div
          className={
            mobileView
              ? classNames(fontSize14)
              : classNames(fontSize16, fontWeight500)
          }
        >
          {message}
        </div>

        <button
          type="submit"
          className={classNames(
            "btn rounded-pill mt-3 col-6 col-md-4 ",
            formSubmitButton,
            fontWeight500
          )}
          onClick={handleClick}
        >
          OK
        </button>
      </div>
    </ModalBox>
  );
};

ErrorMessageModal.propTypes = {
  message: PropTypes.string,
  show: PropTypes.bool,
  onClickSubmit: PropTypes.func,
  toggle: PropTypes.func,
};

ErrorMessageModal.defaultProps = {
  onClickSubmit: () => {},
};

export default ErrorMessageModal;
